import React from 'react';
import { NumberFieldProps } from './types';

const NumberField: React.FC<NumberFieldProps> = ({
  id,
  label,
  value,
  onChange,
  disabled = false,
  required = false,
  placeholder = ' ',
  onFocus,
  onBlur,
  hasValue,
  getFloatingLabelStyle,
  getFloatingInputStyle,
  styles,
  min,
  max,
  step,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!onChange) return;

    const rawValue = e.target.value;
    if (rawValue === '') {
      onChange(null);
      return;
    }

    const numValue = parseFloat(rawValue);
    if (isNaN(numValue)) {
      return; // Don't update if invalid number
    }

    onChange(numValue);
  };

  return (
    <div style={styles.floatingFieldContainer}>
      <input
        id={id}
        type="number"
        value={value !== null && value !== undefined ? value.toString() : ''}
        onChange={handleChange}
        disabled={disabled}
        onFocus={onFocus}
        onBlur={onBlur}
        style={getFloatingInputStyle(false, id)}
        placeholder={placeholder}
        min={min}
        max={max}
        step={step}
      />
      <label htmlFor={id} style={getFloatingLabelStyle(id, hasValue)}>
        {label}
        {required && <span style={{ color: 'red' }}>*</span>}
      </label>
    </div>
  );
};

export default React.memo(NumberField);
